import moment from 'moment'
import _ from 'common-tools/LodashHelper'
const queryString = require('query-string')

export const FormatHelper = {
  Date: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.OnlyDate || 'MM?DD?YYYY')
    } else {
      return '??'
    }
  },
  DateTime: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.DateAndTime || 'MM?DD?YYYY h?mm a')
    } else {
      return '??'
    }
  },
  Time: (dateText, DateFormat = {}) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format(DateFormat.OnlyTime || 'h?mm a')
    } else {
      return '??'
    }
  },
  DateLongText: (dateText) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.format('dddd, MMMM Do YYYY')
    } else {
      return '??'
    }
  },
  FromNow: (dateText) => {
    if (!dateText) {
      return ''
    }
    const parsedDate = moment(dateText)
    if (parsedDate.isValid()) {
      return parsedDate.fromNow()
    } else {
      return '??'
    }
  },
  FromOptions: (value, options, valueProp = 'Value', textProp = 'Text') => {
    if (_.isArray(options) && options.length > 0) {
      if (!value) {
        return value
      } else {
        let valueHasMatch = _.find(options, (o) => { return o[valueProp] === value })

        if (!valueHasMatch) {
          return value
        } else {
          return valueHasMatch[textProp]
        }
      }
    } else {
      return value
    }
  },
  QueryString: (rawString) => {
    return queryString.parse(rawString)
  },
  BuildTimeOptions (dayStart, dayStop) {
    let timeStart = dayStart || '00:00'
    let timeStop = dayStop || '00:00'

    let currentDate = moment('2000-01-01').format('YYYY-MM-DD')
    let listStartTime = moment(`${currentDate}T${timeStart}`)
    let listEndTime = moment(`${currentDate}T${timeStop}`)

    if (timeStop === '00:00') {
      listEndTime = listEndTime.add(1, 'd')
    }

    let ret = []

    while (listStartTime.isSameOrBefore(listEndTime) === true) {
      ret.push({
        Text: listStartTime.format('h:mm a'),
        Value: listStartTime.format('HH:mm')
      })
      listStartTime.add(15, 'm')
    }

    return ret
  },
  BuildYearOptions (start = 1944, stop) {
    let lstop = stop || moment().add(1, 'year').year()
    let ret = []
    let loop = start
    for (loop = lstop; loop >= start; loop--) {
      ret.push({
        Text: loop,
        Value: loop
      })
    }
    return ret
  },
  RoundTime: (time, minutesToRound = 15) => {
    let [hours, minutes] = time.split(':')
    hours = parseInt(hours)
    minutes = parseInt(minutes)

    // Convert hours and minutes to time in minutes
    time = (hours * 60) + minutes

    let rounded = Math.round(time / minutesToRound) * minutesToRound
    let rHr = '' + Math.floor(rounded / 60)
    let rMin = '' + rounded % 60

    return rHr.padStart(2, '0') + ':' + rMin.padStart(2, '0')
  },
  TruncateText: (text, length) => {
    var val = text || ''
    return (val.length > length) ? val.substr(0, length - 1) + '...' : val
  },
  ToBase64: (file) => new Promise((resolve, reject) => {
    var reader = new FileReader() // eslint-disable-line
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }),
  convertToUTC: ({ FromDate, ToDate }) => {
    if (FromDate !== '' & ToDate !== '') {
      if (moment(FromDate).isValid()) {
        return {
          FromDate: moment(FromDate).utc().toISOString(),
          ToDate: moment(ToDate).utc().toISOString()
        }
      }
    }
  },
  convertDateToUTC: ({ FromDate, ToDate }) => {
    if (FromDate !== '' & ToDate !== '') {
      if (moment(FromDate).isValid()) {
        return {
          FromDate: moment(FromDate).utc().toISOString(),
          ToDate: moment(ToDate).utc().toISOString()
        }
      }
    }
  },
  convertToStartEndOfDay: ({ FromDate, ToDate }) => {
    if (FromDate !== '' & ToDate !== '') {
      if (moment(FromDate).isValid()) {
        return {
          FromDate: moment(FromDate).utc().startOf('day').toISOString(),
          ToDate: moment(FromDate).utc().endOf('day').toISOString()
        }
      }
    }
  },
  convertToStartEndOfDayRaw: ({ FromDate, ToDate }) => {
    if (FromDate !== '' & ToDate !== '') {
      if (moment(FromDate).isValid()) {
        return {
          FromDate: FromDate,
          ToDate: moment(FromDate).utc().endOf('day').toISOString()
        }
      }
    }
  },
  Phone: (phone = '') => {
    let unformattedPhone = (phone || '').toString()
    unformattedPhone = unformattedPhone.split('-').join('')
    if (unformattedPhone) {
      return `(${unformattedPhone.substring(0, 3)}) ${unformattedPhone.substring(3, 6)}-${unformattedPhone.substring(6)}`
    } else {
      return ''
    }
  },
  MBIFormat: /\b[1-9]{1}[^SLOIBZsloibz|^0-9]{1}[^SLOIBZsloibz]{1}[0-9]{1}-?[^SLOIBZsloibz|^0-9]{1}[^SLOIBZsloibz]{1}[0-9]{1}-?[^SLOIBZsloibz|^0-9]{1}[^SLOIBZsloibz|^0-9]{1}[0-9]{1}[0-9]{1}\b/,
  UTN: /^[A-Z0-9]{2}[AH]{1}[0-9]{11}$/,
  GetUTNFormatErrors: (authNumber) => {
    const alphaNumeric14 = /^[A-Z0-9]{14}$/
    const alphaNumeric = /^[A-Z0-9]+$/
    const aorh = /^A|H+$/
    const last11Pos = /^[0-9]{11}$/

    let errors = []
    // 14 digit alpha-numeric unique tracking number (UTN)
    if (!alphaNumeric14.test(authNumber)) {
      errors.push('UTN has to be 14 digit alpha-numeric unique tracking number (UTN)')
    }
    // The first two positions of UTN must be alpha-numeric and cannot contain spaces.
    if (!alphaNumeric.test(authNumber[0]) || !alphaNumeric.test(authNumber[1])) {
      errors.push('The first two positions of UTN must be alpha-numeric and cannot contain spaces.')
    }
    // The third position of UTN is an A or H.
    if (!aorh.test(authNumber[2])) {
      errors.push('The third position of UTN must be an A or H.')
    }
    // The last 11 positions of UTN must be numeric and cannot contain spaces.
    if (!last11Pos.test(authNumber.slice(-11))) {
      errors.push('The last 11 positions of UTN must be numeric and cannot contain spaces.')
    }

    return errors
  },
  GetMBIFormatErrors: (mbi) => {
    const alphaNumeric11 = /^[A-Z0-9]{11}$/
    const numeric19 = /^[1-9]$/
    const numeric09 = /^[0-9]$/
    const alphaNumericExclude = /^[^SLOIBZsloibz]|0-9$/
    const alphaExclude = /^[^SLOIBZsloibz0-9]$/

    let errors = []

    const mbiString = _.join(_.split(mbi, '-'), '')
    // The MBI format is 11 characters is length
    if (!alphaNumeric11.test(mbiString)) {
      errors.push('The MBI format must be 11 characters in length.')
    }
    // Position 1 – numeric values 1 thru 9
    if (!numeric19.test(mbiString[0])) {
      errors.push('Position 1 – must be numeric values 1 thru 9.')
    }
    // Position 2 – alphabetic values A thru Z (exclude S, L, O, I, B, Z)
    if (!alphaExclude.test(mbiString[1])) {
      errors.push('Position 2 – must be alphabetic values A thru Z (exclude S, L, O, I, B, Z).')
    }
    // Position 3 – alpha-numeric values 0 thru 9 and A thru Z (Exclude S, L, O, I, B, Z)
    if (!alphaNumericExclude.test(mbiString[2])) {
      errors.push('Position 3 – must be alpha-numeric values 0 thru 9 and A thru Z (Exclude S, L, O, I, B, Z).')
    }
    // Position 4 – numeric values 0 thru 9
    if (!numeric09.test(mbiString[3])) {
      errors.push('Position 4 – must be numeric values 0 thru 9.')
    }
    // Position 5 – alphabetic values A thru Z (exclude S, L, O, I, B, Z)
    if (!alphaExclude.test(mbiString[4])) {
      errors.push('Position 5 – must be alphabetic values A thru Z (exclude S, L, O, I, B, Z).')
    }
    // Position 6 – alpha-numeric values 0 thru 9 and A thru Z (Exclude S, L, O, I, B, Z)
    if (!alphaNumericExclude.test(mbiString[5])) {
      errors.push('Position 6 – must be alpha-numeric values 0 thru 9 and A thru Z (Exclude S, L, O, I, B, Z).')
    }
    // Position 7 – numeric values 0 thru 9
    if (!numeric09.test(mbiString[6])) {
      errors.push('Position 7 – must be numeric values 0 thru 9.')
    }
    // Position 8 – alphabetic values A thru Z (exclude S, L, O, I, B, Z)
    if (!alphaExclude.test(mbiString[7])) {
      errors.push('Position 8 – must be alphabetic values A thru Z (exclude S, L, O, I, B, Z).')
    }
    // Position 9 – alphabetic values A thru Z (exclude S, L, O, I, B, Z)
    if (!alphaExclude.test(mbiString[8])) {
      errors.push('Position 9 – must be alphabetic values A thru Z (exclude S, L, O, I, B, Z).')
    }
    // Position 10 – numeric values 0 thru 9
    if (!numeric09.test(mbiString[9])) {
      errors.push('Position 10 – must be numeric values 0 thru 9.')
    }
    // Position 11 – numeric values 0 thru 9
    if (!numeric09.test(mbiString[10])) {
      errors.push('Position 11 – must be numeric values 0 thru 9.')
    }
    return errors
  }
}
